import React, { useState, useEffect } from "react";
import { usePlayer } from "../../../../Contexts/playerData.context";
import { useNavigate } from "react-router-dom";
import { getUserFromToken } from "../../../../utils/functions.ts";
import "./transactions.style.scss";

const Transactions = () => {
    const [showHistory, setShowHistory] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [historyData, setHistoryData] = useState([]);
    const [filterDataByLeague, setFilterDataByLeague] = useState("");
    const { playerID } = usePlayer();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSummary = async () => {
            if (!playerID) return;
            const user = await getUserFromToken();
            if (!user || (Array.isArray(user) && user.length === 0)) {
                navigate("/login");
                return;
            }
            try {
                const response = await fetch("https://www.fbxchange.com/ReactPHP/transactions.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ FBXID: playerID, user, script: "getLeagueData" }),
                });
                const data = await response.json();
                setSummaryData(data || []);
            } catch (error) {
                console.error("Error fetching summary data:", error);
                setSummaryData([]);
            }
        };
        setFilterDataByLeague("");
        fetchSummary();
    }, [playerID]);

    useEffect(() => {
        const fetchHistory = async () => {
            if (!playerID || !showHistory) return;
            const user = await getUserFromToken();
            try {
                const res = await fetch("https://www.fbxchange.com/ReactPHP/transactions.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ FBXID: playerID, user, script: "SearchHistory" }),
                });
                const data = await res.json();
                const filtered = filterDataByLeague
                    ? data.filter(item => item.League === filterDataByLeague)
                    : data;
                console.log("Filtered History Data:", filtered);
                setHistoryData(filtered || []);
            } catch (error) {
                console.error("Error fetching history data:", error);
                setHistoryData([]);
            }
        };
        fetchHistory();
    }, [playerID, showHistory, filterDataByLeague]);

    const transBoxStyle = {
        position: "fixed",
        top: "90px",
        right: "10px",
        backgroundColor: "whitesmoke",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        zIndex: 996,
        border: "2px solid darkgray",
        fontSize: "small"
    };

    const filterTransactions = (league) => {
        if (!league) return;
        setShowHistory(true);
        setFilterDataByLeague(league);
    };

return (
     <div id="transbox" className="transBoxStyle col-24" style={transBoxStyle}>
          {summaryData.length === 0 ? (
               <div className="text-center p-3">There are No Transactions for this Athlete</div>
          ) : (
               <>
                    <div className="bg-navy text-lemon d-flex ps-2 pe-2">
                         <div className="p-2 text-center col-6">ORG</div>
                         <div className="p-2 text-center col-6">Team</div>
                         <div className="p-2 text-center col-6">Date</div>
                         <div className="p-2 text-center col-6">Status</div>
                         <div className="p-2 text-center col-6">Pos</div>
                         <div className="p-2 text-center col-6">D.Team</div>
                         <div className="p-2 text-center col-6">D.Round</div>
                         <div className="p-2 text-center flex-grow-1">D.Pick</div>
                    </div>

                    {summaryData.map((item, idx) => (
                         <div
                              key={idx}
                              className={`transactionRow d-flex text-navy align-content-center ${idx === summaryData.length - 1 ? "no-border" : ""} ${filterDataByLeague === item.League ? "alert-danger" : ""}`}
                              onClick={() => filterTransactions(item.League)}
                         >
                              <div className="col-6 text-center p-2">{item.League}</div>
                              <div className="col-6 text-center p-2">{item.Team}</div>
                              <div className="col-6 text-center p-2">{item.theDate}</div>
                              <div className="col-6 text-center p-2">{item.Status}</div>
                              <div className="col-6 text-center p-2">{item.Position}</div>
                              <div className="col-6 text-center p-2">{item.DTeam}</div>
                              <div className="col-6 text-center p-2">{item.DRound}</div>
                              <div className="flex-grow-1 text-center p-2">{item.DPick}</div>
                         </div>
                    ))}

                    {summaryData.length > 0 && (
                         <div
                              className={`btn btn-sm w-100 text-center mt-4 ${showHistory ? "btn-warning" : "btn-outline-navy"}`}
                              onClick={() => { setShowHistory(!showHistory); setFilterDataByLeague(""); }}
                         >
                              {showHistory ? "Hide Transaction History" : "Show Transaction History"}
                         </div>
                    )}

                    {showHistory && historyData.length > 0 && (
                         <div className="transaction-history-scroll mt-3">
                              <div className="bg-navy text-lemon d-flex ps-2 pe-2">
                                   <div className="p-2 text-center col-3">ORG</div>
                                   <div className="p-2 text-center col-3">Team</div>
                                   <div className="p-2 text-center col-7">Date</div>
                                   <div className="p-2 text-center col-3">Status</div>
                                   <div className="p-2 text-center col-4">Year</div>
                                   <div className="p-2 text-center col-3">Pos</div>
                                   <div className="p-2 flex-grow-1">Note</div>
                              </div>

                              <div className="history-scroll-body">
                                   {historyData.map((item, idx) => (
                                        <div
                                             key={idx}
                                             className={`transactionRow d-flex text-navy align-items-center pe-2 ps-2 ${idx === historyData.length - 1 ? "no-border" : ""}`}
                                        >
                                             <div className="col-3 text-center p-2">{item.League}</div>
                                             <div className="col-3 text-center p-2">{item.A_ProTeam}</div>
                                             <div className="col-7 text-center p-2">{item.ProTeamDate}</div>
                                             <div className="col-3 text-center p-2">{item.ProTeamStatus}</div>
                                             <div className="col-4 text-center p-2">{item.TeamYear}</div>
                                             <div className="col-3 text-center p-2">{item.A_ProPos}</div>
                                             <div
                                                  className="col-25 p-2 text-truncate text-start"
                                                  title={item.ST_NOTES}
                                                  style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                                             >
                                                  {item.ST_NOTES}
                                             </div>
                                        </div>
                                   ))}
                              </div>
                         </div>
                    )}
               </>
          )}
     </div>
);
};

export default Transactions;
